module.exports = __webpack_public_path__ + "images/fill-blank-typing.webp";